import * as React from "react";

export const TLetter = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.40002 5.11447C4.40002 4.78309 4.66865 4.51447 5.00002 4.51447L11 4.51447C11.3314 4.51447 11.6 4.7831 11.6 5.11447C11.6 5.44584 11.3314 5.71447 11 5.71447L8.60002 5.71447V12.0856C8.60002 12.417 8.3314 12.6856 8.00002 12.6856C7.66865 12.6856 7.40002 12.417 7.40002 12.0856V5.71447L5.00002 5.71447C4.66865 5.71447 4.40002 5.44584 4.40002 5.11447Z"
    />
);
